import React from 'react';
import { Title, Button, GameContainer, Background, Ground } from '../styles/StyledComponents';

interface MainMenuProps {
  highScore: number;
  totalCoins: number;
  onStartGame: () => void;
  onOpenSettings: () => void;
  onOpenShop: () => void;
}

const MainMenu: React.FC<MainMenuProps> = ({ 
  highScore, 
  totalCoins, 
  onStartGame, 
  onOpenSettings, 
  onOpenShop 
}) => {
  return (
    <GameContainer>
      <Background />
      <Ground />
      
      <Title>닌자 러너</Title>
      
      <Button onClick={onStartGame}>게임 시작</Button>
      <Button onClick={onOpenShop}>상점</Button>
      <Button onClick={onOpenSettings}>설정</Button>
      
      {highScore > 0 && (
        <div style={{ marginTop: '20px', textAlign: 'center', color: 'white' }}>
          <p>최고 점수: {highScore}</p>
          <p>보유 코인: {totalCoins}</p>
        </div>
      )}
    </GameContainer>
  );
};

export default MainMenu;
